import { Route, Routes } from 'react-router-dom';

import ProgressBarForm from './ProgressBarForm';
import { ProgressBarsTable } from './ProgressBarsTable';

const ProgressBarsView = () => {
  return (
    <Routes>
      <Route path="/" element={<ProgressBarsTable />} />
      <Route path="/form" element={<ProgressBarForm />} />
      <Route
        path="/form/:progressBarId"
        element={<ProgressBarForm edit={true} />}
      />
      <Route
        path="/dup/:progressBarId"
        element={<ProgressBarForm edit={false} dup={true} />}
      />
    </Routes>
  );
};

export default ProgressBarsView;
